
import React from 'react';
import { HelpCircle } from 'lucide-react';

const Tooltip = ({ text }: { text: string }) => {
  return (
    <span className="relative group">
      <HelpCircle className="w-4 h-4 text-gray-400 cursor-pointer ml-1" />
      <span className="absolute bottom-full mb-2 w-64 p-2 bg-gray-800 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-10">
        {text}
      </span>
    </span>
  );
};

export default Tooltip;
